<div class="administrative-dashboard anim-loading"
  *appAdminPermission="['ViewAppraisal', 'ViewContract', 'ViewCompany']">
  <div class="container">
    <div class="page-title">
      <h2 i18n>Administrativo</h2>
      <p class="page-title__subtitle" i18n>Escolha a funcionalidade que deseja
        acessar</p>
    </div>

    <div class="mt-4 mb-5">
      <h6 i18n>Cadastros</h6>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3"
          *appAdminPermission="['ViewContract', 'CreateContract', 'DeleteContract', 'UpdateContract']">
          <a routerLink="manage-contract"
            class="administrative-dashboard__block">
            <i class="material-icons">receipt_long</i>
            <span i18n>Gerenciar Contrato</span>
          </a>
        </div>
        <div class="col-12 col-sm-6 col-md-3"
          *appAdminPermission="['ViewAppraisal', 'CreateAppraisal', 'DeleteAppraisal', 'UpdateAppraisal']">
          <a routerLink="manage-appraisal"
            class="administrative-dashboard__block">
            <i class="material-icons">task</i>
            <span i18n>Gerenciar Certificado</span>
          </a>
        </div>
        <div class="col-12 col-sm-6 col-md-3"
          *appAdminPermission="['ViewCompany', 'CreateCompany', 'DeleteCompany', 'UpdateCompany']">
          <a routerLink="manage-company"
            class="administrative-dashboard__block">
            <i class="material-icons">domain</i>
            <span i18n>Gerenciar Empresa</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="administrative-dashboard anim-loading"
  *ngIf="currentUser?.adminManagerUser || currentUser?.superUser">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="pt-5">
          <a routerLink="/administrative/manage-module"
            class="btn btn-fade-secondary btn-icon" i18n>
            <i class="material-icons">settings_applications</i> Administrar
            Módulo
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
